;(function (angular, _, moment) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .directive('queryBuilder', QueryBuilderDirective)

  QueryBuilderDirective.$inject = [
    // Angular
    // Libs
    // Managers
    'UserManager'
    // Services
    // Const
    // Resolved
  ]

  function QueryBuilderDirective (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'E',
      scope: true,
      bindToController: {
        query: '=',
        concern: '='
      },
      controllerAs: 'ctrl',
      controller: QueryBuilderController,
      templateUrl: '/app/modules/dashboard/directives/query-builder/query-builder.template.html'
    }
  }

  QueryBuilderController.$inject = [
    // Angular
    // Libs
    // Managers
    'UserManager', 'CustomFieldManager', 'InvoiceManager', 'QuoteManager',
    // Services
    'DatePickerService', 'FilterService', 'StatusService', 'AppAccessService',
    // Const
    // Resolved
    'chorusStatuses'
  ]

  function QueryBuilderController (
    // Angular
    // Libs
    // Managers
    UserManager, CustomFieldManager, InvoiceManager, QuoteManager,
    // Services
    DatePickerService, FilterService, StatusService, AppAccessService,
    // Const
    // Resolved
    chorusStatuses
  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    const customRangeCreatedAt = [
      {
        label: 'année dernière',
        range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
      },
      {
        label: 'mois dernier',
        range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
      },
      {
        label: 'semaine dernière',
        range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
      },
      {
        label: 'hier',
        range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
      },
      {
        label: 'aujourd\'hui',
        range: moment().range(moment().startOf('day'), moment().endOf('day'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        manager: self.concern === 'invoice' ? InvoiceManager : QuoteManager,
        invoiceStatuses: StatusService.getStatuses('invoice'),
        cancelByUsers: [
          { label: 'oui', value: true, _id: 'cancel' },
          { label: 'non', value: false, _id: 'cancel' }
        ],
        quoteStatuses: StatusService.getStatuses('quote'),
        creditNoteStatuses: StatusService.getStatuses('creditnote'),
        haveChorusAccess: false,
        statutsCourantChorus: chorusStatuses,
        // Public Methods
        addCriteria: addCriteria,
        getCorrectQb: getCorrectQb,
        resetQuery: resetQuery,
        searchClients: searchClients,
        searchCreditNoteRef: searchCreditNoteRef,
        searchCreditNoteTitle: searchCreditNoteTitle,
        searchInvoice: searchInvoice,
        searchInvoiceRef: searchInvoiceRef,
        searchInvoiceTitle: searchInvoiceTitle,
        searchProductCategory: searchProductCategory,
        searchProductLabel: searchProductLabel,
        searchProductRef: searchProductRef,
        searchQuoteRef: searchQuoteRef,
        searchQuoteTitle: searchQuoteTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        searchDeliveries: searchDeliveries
      })

      init()
    }

    function init () {
      AppAccessService.getCompanyRights().then((rights) => {
        rights.forEach((right) => {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true
        })
      })
      UserManager.getReferers().then(function (data) {
        self.referers = data.data
      })
      CustomFieldManager.get(CustomFieldManager.query().select('invoice', 'model'))
        .then(function (data) {
          self.invoiceCustomFields = data.data
        })
      CustomFieldManager.get(CustomFieldManager.query().select('quote', 'model'))
        .then(function (data) {
          self.quoteCustomFields = data.data
        })
      CustomFieldManager.get(CustomFieldManager.query().select('creditnote', 'model'))
        .then(function (data) {
          self.creditNoteCustomFields = data.data
        })
    }

    function resetQuery () {
      self.query = {}
      addCriteria('isArchived', { _id: 'archived', value: false })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.query = FilterService.addCriteria(self.query, key, value, negation)
      }
      self.query = FilterService.sanitizeSearchTree(self.query, true)
    }

    function searchProductRef (search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchProductLabel (search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels
      })
    }

    function searchProductCategory (search) {
      return FilterService.searchProductCategories(search).then(function (categories) {
        self.categories = categories
      })
    }

    function searchTags (query) {
      return FilterService.searchTags(query)
    }

    function searchInvoiceRef (search) {
      return FilterService.searchInvoiceRef(search).then(function (refs) {
        self.refs = refs
      })
    }
    function searchInvoice (search) {
      return FilterService.searchInvoice(search).then(function (invoices) {
        self.invoices = invoices
      })
    }

    function searchInvoiceTitle (search) {
      return FilterService.searchInvoiceTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchClients (search) {
      if (search) {
        FilterService.simpleSearchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchDeliveries (search) {
      if (search) {
        FilterService.simpleSearchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data
        })
      }
    }

    function searchQuoteRef (search) {
      return FilterService.searchQuoteRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchQuoteTitle (search) {
      return FilterService.searchQuoteTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchCreditNoteTitle (search) {
      return FilterService.searchCreditNoteTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchCreditNoteRef (search) {
      return FilterService.searchCreditNoteRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function selectDateRange () {
      DatePickerService.getRange(self.query.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('date', dates)
      })
    }

    function selectDueDateRange () {
      DatePickerService.getRange(self.query.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates)
      })
    }

    function selectCreatedAtRange () {
      DatePickerService.getRange(self.query.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeCreatedAt
      }).then(function (dates) {
        addCriteria('createdAt', dates)
      })
    }

    function getCorrectQb () {
      if (self.concern === 'deposit') {
        return '/app/modules/dashboard/services/templates/invoice-qb.template.html'
      }
      return '/app/modules/dashboard/services/templates/' + self.concern + '-qb.template.html'
    }
  }
})(window.angular, window._, window.moment)
